import React from "react";
import PatientMedicationSection from "./PatientMedicationSection";

const PatientMedicationTab = ({
  patientId,
  patient,
  chartId,
  canEdit,
  onRefresh,
}) => (
  <PatientMedicationSection
    patientId={patientId}
    patient={patient}
    chartId={chartId}
    canEdit={canEdit}
    onRefresh={onRefresh}
  />
);

export default PatientMedicationTab;
